/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { createSelector } from '@ngrx/store';
import { SelectCalculatedUsersDictionary } from './select-calculated-users/select-calculated-users.selector';
import { SelectUserState } from './select-user-state';

const SelectUserByEmail = (email: string) => createSelector(SelectUserState, (userState) => userState.entities[email]);
const SelectIsInitialized = createSelector(SelectUserState, (userState) => userState.isLoaded);

export const UserSelectors = {
  SelectIsInitialized,
  SelectUserState,
  SelectUserByEmail,
  SelectCalculatedUsersDictionary,
  SelectIsLoading: createSelector(SelectUserState, (state) => state.isLoading)
};
